import styled from 'styled-components';

export default styled.div`
  padding: 0 2rem 3rem 2rem;
`;
